// NOTE: ENquiries are a unique model as if we try to clone null it just
// returns a fresh Enquiry object.

import { Model, RailsFormat } from "./model"
import { Utilities } from "@helpers/utilities"

export class Enquiry extends Model implements RailsFormat {

  constructor(
    public id?: number,
    public guid: string = null,
    public courseIds: number[] = [],
    public campusIds: number[] = [],
    public matrixClassIds: number[] = [],
    public isInternal: boolean = false,
    public step: number = 1,
    public quickFullName: string = null,
    public quickEmail: string = null,
    public quickMobile: string = null,
    public quickContactType: string = "parent",
    public studentFirstName: string = null,
    public studentLastName: string = null,
    public studentGender: number = null,
    public studentPhone: string = null,
    public studentDob: Date = new Date(),
    public studentEmail: string = null,
    public parentFirstName: string = null,
    public parentLastName: string = null,
    public parentGender: number = 0,
    public parentPhone: string = null,
    public parentDob: Date = new Date(),
    public parentEmail: string = null,
    public grade: number = 7,
    public currentGrade: number = null,
    public school: string = null,
    public isOnWaitingList: boolean = false,
    public enquiryStatus: number = 0,
    public preferredContact: number = 1,
    public updatedAt: Date = null,
    public createdAt: Date = null,
  ) {
    super()
  }

  static clone(obj: any) {
    const enquiry: Enquiry = new this()

    if (!obj) { return enquiry }

    if (obj.id) { enquiry.id = obj.id }
    if (obj.guid) { enquiry.guid = obj.guid }
    if (obj.courseIds) { enquiry.courseIds = obj.courseIds }
    if (obj.campusIds) { enquiry.campusIds = obj.campusIds }
    if (obj.matrixClassIds) { enquiry.matrixClassIds = obj.matrixClassIds }
    if (obj.isInternal) { enquiry.isInternal = obj.isInternal }
    if (obj.step) { enquiry.step = obj.step }
    if (obj.quickFullName) { enquiry.quickFullName = obj.quickFullName }
    if (obj.quickEmail) { enquiry.quickEmail = obj.quickEmail }
    if (obj.quickMobile) { enquiry.quickMobile = obj.quickMobile }
    if (obj.quickContactType) { enquiry.quickContactType = obj.quickContactType }
    if (obj.studentFirstName) { enquiry.studentFirstName = obj.studentFirstName }
    if (obj.studentLastName) { enquiry.studentLastName = obj.studentLastName }
    if (obj.studentGender != null) { enquiry.studentGender = obj.studentGender }
    if (obj.studentPhone) { enquiry.studentPhone = obj.studentPhone }
    if (obj.studentDob) { enquiry.studentDob = Utilities.makeDate(obj.studentDob) }
    if (obj.studentEmail) { enquiry.studentEmail = obj.studentEmail }
    if (obj.parentFirstName) { enquiry.parentFirstName = obj.parentFirstName }
    if (obj.parentLastName) { enquiry.parentLastName = obj.parentLastName }
    if (obj.parentGender != null) { enquiry.parentGender = obj.parentGender }
    if (obj.parentPhone) { enquiry.parentPhone = obj.parentPhone }
    if (obj.parentEmail) { enquiry.parentEmail = obj.parentEmail }

    if (obj.grade) { enquiry.grade = obj.grade }
    if (obj.currentGrade) { enquiry.currentGrade = obj.currentGrade }
    if (obj.school) { enquiry.school = obj.school }
    if (obj.isOnWaitingList) { enquiry.isOnWaitingList = obj.isOnWaitingList }
    if (obj.enquiryStatus) { enquiry.enquiryStatus = obj.enquiryStatus }
    if (obj.preferredContact) { enquiry.preferredContact = obj.preferredContact }

    if (obj.updatedAt) { enquiry.updatedAt = new Date(obj.updatedAt) }
    if (obj.createdAt) { enquiry.createdAt = new Date(obj.createdAt) }

    if (obj.errors && Object.keys(obj.errors).length > 0) {
      enquiry.errors = Model.getJsonApiErrors(obj.errors)
    }

    return enquiry
  }

  serializeForRails(): any {
    const response: any = Object.assign({}, this) 

    if (this.id === 0) { response.id = null }

    return response
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/enquiry.ts